import { MagnifyingGlassIcon, XIcon } from "@phosphor-icons/react";
import { IconButton, TextField } from "@radix-ui/themes";

export interface SymbolSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  ariaLabel?: string;
  clearAriaLabel?: string;
}

/**
 * Symbol search for the positions filter row. It shrinks before it disappears
 * so bulk-action controls can take the width back without wrapping the row.
 */
export const SymbolSearchField = ({
  value,
  onChange,
  onClear,
  ariaLabel = "Search positions by symbol",
  clearAriaLabel = "Clear symbol search",
}: SymbolSearchFieldProps) => (
  <TextField.Root
    size="1"
    value={value}
    onChange={(event) => onChange(event.currentTarget.value)}
    onKeyDown={(event) => {
      if (event.key === "Escape" && value) {
        event.stopPropagation();
        onClear();
      }
    }}
    placeholder="Search symbol"
    aria-label={ariaLabel}
    className="min-w-[6rem] max-w-[14rem] flex-1 basis-[9rem]"
  >
    <TextField.Slot>
      <MagnifyingGlassIcon size={14} aria-hidden />
    </TextField.Slot>
    {value ? (
      <TextField.Slot side="right">
        <IconButton
          size="1"
          variant="ghost"
          color="gray"
          aria-label={clearAriaLabel}
          onClick={onClear}
        >
          <XIcon size={14} aria-hidden />
        </IconButton>
      </TextField.Slot>
    ) : null}
  </TextField.Root>
);
